export function formatPhone(phone) {
  if (phone && typeof phone === "string") {
    const formatedPhone = phone.includes("+55") ? phone : "+55" + phone
    return formatedPhone.substring(3, 100).replace(
      /^(\d{2})(\d{5})(\d{4})/,
      "($1) $2-$3"
    )
  }

  return "--"
}